<template id="countdown-template">
  <div class="time">
    <span class="hour">{{ hours ? hours : '00' | twoDigits }} : </span>
    <span class="minute">{{ minutes ? minutes : '00' | twoDigits }} : </span>
    <span class="second">{{ seconds ? seconds : '00' | twoDigits }}</span>
  </div>
</template>

<script>
export default {
  name: "countDown",
  props: {
    endHourDate: {
      type: String
    },
    serverTime: {
      type: String
    },
    expectedNow: {
      type: String
    },
    isPreview: {
      type: Boolean
    }
  },
  data() {
    return {
      differentTimeZone: Math.trunc(new Date(this.isPreview ? this.expectedNow : this.serverTime).getTime() / 1000) - Math.trunc(new Date().getTime() / 1000),
      now: Math.trunc(new Date(this.isPreview ? this.expectedNow : this.serverTime).getTime() / 1000) + Math.trunc(new Date().getTime() / 1000),
    };
  },
  computed: {
    dateInMilliseconds() {
      return Math.trunc(Date.parse(this.endHourDate) / 1000);
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    test(){
      return this.now
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    }
  },
  filters: {
    twoDigits: function(value) {
      if (value < 0) {
        return "00";
      }
      if (value.toString().length <= 1) {
        return `0${value}`;
      }
      return value;
    }
  },
  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000) + this.differentTimeZone;
    }, 1000);
  }
};
</script>

<style src="./Countdown.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/components/countDown/countDown.vue